import { render, staticRenderFns } from "./popup-role.vue?vue&type=template&id=0faf63e9&scoped=true"
import script from "./popup-role.vue?vue&type=script&lang=js"
export * from "./popup-role.vue?vue&type=script&lang=js"
import style0 from "./popup-role.vue?vue&type=style&index=0&id=0faf63e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf63e9",
  null
  
)

export default component.exports